/******************** WISHLIST LIST AND GRID JS START ************************/

// document.addEventListener("DOMContentLoaded", function () {
//   const layoutButtons = document.querySelectorAll(
//     "[data-action='change-layout']"
//   );
//   const wishlistContainer = document.querySelector(".wishlist-product--list");

//   if (!layoutButtons || !wishlistContainer) return;

//   layoutButtons.forEach((button) => {
//     button.addEventListener("click", function () {
//       const selectedLayout = this.getAttribute("data-layout-mode");

//       // Remove any existing layout classes
//       wishlistContainer.classList.remove("grid-view", "list-view");

//       // Add the new layout class
//       if (selectedLayout === "grid") {
//         wishlistContainer.classList.add("grid-view");
//       } else {
//         wishlistContainer.classList.add("list-view");
//       }

//       // Highlight the selected button
//       layoutButtons.forEach((btn) => btn.classList.remove("is-selected"));
//       this.classList.add("is-selected");
//     });
//   });
// });

document.addEventListener("DOMContentLoaded", function () {
  const wishlistContainer = document.querySelector(".wishlist-product--list");
  const layoutButtons = document.querySelectorAll(
    "[data-action='change-layout']"
  );

  if (!wishlistContainer) return;

  // 🔒 Always force grid view
  wishlistContainer.classList.remove("list-view");
  wishlistContainer.classList.add("grid-view");

  // Optional: handle buttons (grid only)
  layoutButtons.forEach((button) => {
    const layout = button.getAttribute("data-layout-mode");

    if (layout === "grid") {
      button.classList.add("is-selected");
    } else {
      // Disable list view button completely
      button.style.display = "none";
    }

    button.addEventListener("click", function (e) {
      e.preventDefault();

      // Force grid even on click
      wishlistContainer.classList.remove("list-view");
      wishlistContainer.classList.add("grid-view");

      layoutButtons.forEach((btn) => btn.classList.remove("is-selected"));
      button.classList.add("is-selected");
    });
  });
});

/******************** WISHLIST LIST AND GRID JS END ************************/

const LOCAL_STORAGE_WISHLIST_KEY = "shopify-wishlist";
const BUTTON_ACTIVE_CLASS = "wishlist-active";

const selectors = {
  wishlistButton: "[button-wishlist]",
  removeWishlistBtn: ".wishList_remove--btn-js",
  productGridContainer: ".product-list--collection",
  recentlyViewedSection: '[data-section-type="recently-viewed-products"]',
  recommendedProductsSection: '[data-section-type="product-recommendations"]',
  // filtersForm: "#desktop-filters-form",
  filtersForm: "#mobile-collection-filters-form",
  // clearFilterBtn: ".collection__clear-filter",
  clearFilterBtn: '[data-action="clear-filters"]',
  activeFilterCross: ".collection__active-filter-cross",
  headerWishlistIcon: ".header__action-list .wishlist--wrapper",
};


let wishlistButtonsInitialized = false;

// ======== Wishlist Core Logic ========
function wishListShowTheActive() {
  // Initialize wishlist toggle buttons on products
  const setupWishlistButtons = (buttons) => {
    buttons.forEach((button) => {
      try {
        const productData = JSON.parse(button.dataset.product);
        if (!productData?.id) return;

        // Remove old listener before adding new one (prevent duplicates)
        button.removeEventListener("click", button._wishlistHandler);

        button._wishlistHandler = () => {
          updateWishlist(productData);
          button.classList.toggle(BUTTON_ACTIVE_CLASS);

          if (button.classList.contains(BUTTON_ACTIVE_CLASS)) {
            button.setAttribute("data-tooltip","Remove from Wishlist");
          } else {
            button.setAttribute("data-tooltip","Add to Wishlist");
          }

          if(button._tooltip){
            button._tooltip.innerText = button.getAttribute("data-tooltip");
          }

          updateHeaderWishlistIcon();
        };
        button.addEventListener("click", button._wishlistHandler);

        // Set active state based on wishlist content
        if (wishlistContains(productData.id)) {
          button.classList.add(BUTTON_ACTIVE_CLASS);
          button.setAttribute("data-tooltip","Remove from Wishlist");
        } else {
          button.classList.remove(BUTTON_ACTIVE_CLASS);
          button.setAttribute("data-tooltip","Add to Wishlist");
        }
      } catch (e) {
        console.log("[Wishlist] Invalid product data:", e);
      }
    });
  };

  // Setup remove buttons specifically on the wishlist page
  const setupRemoveButtons = (removeButtons) => {
    removeButtons.forEach((button) => {
      const encodedProduct = button.getAttribute("data-product");
      if (!encodedProduct) return;

      let productData = null;
      try {
        productData = JSON.parse(decodeURIComponent(encodedProduct));
      } catch {
        return;
      }
      if (!productData?.id) return;

      button.addEventListener("click", () => {
        // update localStorage
        updateWishlist(productData);

        // remove item DOM element (assuming wrapper has class "wishlist-item")
        const wishlistItem = button.closest(".wishlist-product--wrapper");
        if (wishlistItem) {
          wishlistItem.remove();
        }

        // update header counter
        updateHeaderWishlistIcon();

        // optional: dispatch event so other scripts can listen
        document.dispatchEvent(
          new CustomEvent("shopify-wishlist:item-removed", {
            detail: { product: productData },
          })
        );
      });
    });
  };

  // Initialize wishlist buttons
  const initButtons = () => {
    const buttons = document.querySelectorAll(selectors.wishlistButton);
    
    if (!buttons.length) return;

    setupWishlistButtons(buttons);

    if (!wishlistButtonsInitialized) {
      document.dispatchEvent(
        new CustomEvent("shopify-wishlist:init-buttons", {
          detail: { wishlist: getWishlist() },
        })
      );
      wishlistButtonsInitialized = true;
    }
  };

  // If on wishlist page, initialize remove buttons
  if (["wishlist", "wish-list"].some(word => window.location.href.includes(word))) {
    const intervalId = setInterval(() => {
      const removeButtons = document.querySelectorAll(
        selectors.removeWishlistBtn
      );
      if (removeButtons.length > 0) {
        clearInterval(intervalId);
        setupRemoveButtons(removeButtons);
      }
    }, 500);
  }

  initButtons();
  updateHeaderWishlistIcon();
}

// ======== Wishlist Utilities ========
function getWishlist() {
  try {
    const stored = localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY);
    return Array.isArray(JSON.parse(stored)) ? JSON.parse(stored) : [];
  } catch {
    return [];
  }
}

function setWishlist(wishlist) {
  localStorage.setItem(LOCAL_STORAGE_WISHLIST_KEY, JSON.stringify(wishlist));
  document.dispatchEvent(
    new CustomEvent("shopify-wishlist:updated", {
      detail: { wishlist },
    })
  );
  updateHeaderWishlistIcon();
}

function updateWishlist(product) {
  const wishlist = getWishlist();
  const index = wishlist.findIndex((item) => item.id === product.id);

  if (index === -1) {
    wishlist.push({ ...product, added_at: new Date().toISOString() });
  } else {
    wishlist.splice(index, 1);
  }

  setWishlist(wishlist);
}

function wishlistContains(productId) {
  return getWishlist().some((item) => item.id === productId);
}

function updateHeaderWishlistIcon() {
  const wishlistCount = document.querySelector(".header__wishlist-count");
  const wishlist = getWishlist();
  if (wishlistCount) {
    wishlistCount.textContent = wishlist.length;
    // console.log("item--count = " , wishlistCount);
  }

  // If wishlist is empty, show empty state
  if (wishlist.length === 0) {
    const container = document.querySelector(".wishlist-product--list");
    if (container) {
      container.innerHTML = `<p class="wishlist-empty">No product in wishlist!</p>`;
    }
  }

}

document.addEventListener("DOMContentLoaded", () => {
  wishListShowTheActive();

  let currentProductGrid = document.querySelector(
    selectors.productGridContainer
  );

  // Attach observer if found
  let observer;
  const attachObserver = (target) => {
    if (!target) return;
    observer = new MutationObserver(() => {
      console.log("Mutation detected - reinitializing wishlist buttons");
      wishListShowTheActive();
    });
    observer.observe(target, { childList: true, subtree: true });
  };

  attachObserver(currentProductGrid);

  // Re-attach observer if product grid replaced
  setInterval(() => {
    const newGrid = document.querySelector(selectors.productGridContainer);
    if (newGrid && newGrid !== currentProductGrid) {
      console.log("Product grid replaced - reattaching observer");
      currentProductGrid = newGrid;
      observer.disconnect();
      attachObserver(newGrid);
      wishListShowTheActive();
    }
  }, 1000);

  // Clear filters button
  document.body.addEventListener("click", (e) => {
    if (e.target.closest(selectors.clearFilterBtn)) {
      setTimeout(() => {
        console.log("Clear filter clicked - reinit wishlist");
        wishListShowTheActive();
      }, 1000);
    }
  });

  // Active filter cross
  document.body.addEventListener("click", (e) => {
    if (e.target.closest(selectors.activeFilterCross)) {
      setTimeout(() => {
        console.log("Individual filter removed - reinit wishlist");
        wishListShowTheActive();
      }, 1000);
    }
  });

  // Filter form change
  document.body.addEventListener("change", (e) => {
    if (e.target.closest(selectors.filtersForm)) {
      setTimeout(() => {
        console.log("Filter form changed - reinit wishlist");
        wishListShowTheActive();
      }, 1000);
    }
  });

  // Range slider debounce
  let rangeDebounceTimeout;
  document.body.addEventListener("input", (e) => {
    if (
      e.target.closest(selectors.filtersForm) &&
      e.target.matches('input[type="range"]')
    ) {
      clearTimeout(rangeDebounceTimeout);
      rangeDebounceTimeout = setTimeout(() => {
        wishListShowTheActive();
      }, 1000);
    }
  });
});

// ======== Recently Viewed Section Dynamic Init ========
const recentInterval = setInterval(() => {
  const section = document.querySelector(selectors.recentlyViewedSection);
  if (section) {
    clearInterval(recentInterval);
    setTimeout(() => {
      console.log("Recently viewed section loaded - reinit wishlist");
      wishListShowTheActive();
    }, 500);
  }
}, 1000);

// ======== Recommended Products Section ========
const recommendedProductsSection = document.querySelector(
  selectors.recommendedProductsSection
);

if (recommendedProductsSection) {
  initRecommendedProductsWishlist();
}

function initRecommendedProductsWishlist() {
  const buttons = recommendedProductsSection.querySelectorAll(
    `.recommended--product ${selectors.wishlistButton}`
  );

  buttons.forEach((button) => {
    button.addEventListener("click", () => {
      const productId = button.getAttribute("data-product");

      button.classList.toggle(BUTTON_ACTIVE_CLASS);
      toggleWishlistById(productId);
    });
  });
}

function toggleWishlistById(productId) {
  let wishlist = getWishlist();
  const index = wishlist.findIndex((item) => item.id === productId);

  if (index === -1) {
    wishlist.push({
      id: productId,
      added_at: new Date().toISOString(),
    });
  } else {
    wishlist.splice(index, 1);
  }

  setWishlist(wishlist);
}


document.addEventListener("click", function(e) {

  const pageLink = e.target.closest('.surfer--pagination__nav-item.link, .surfer--pagination__next, .surfer--pagination__prev');

  if (pageLink) {
    const page = pageLink.getAttribute("data-page");

    paginationPageChange(page);
  }

});

function paginationPageChange(page){
  // console.log("Page change ho raha hai:", page);
      setTimeout(() => {
        console.log("Clear filter clicked - reinit wishlist");
        wishListShowTheActive();
      }, 1000);
}


/******************* VARIATION TOOLTIP JS START *******************/ 

document.addEventListener("mouseover", function(e){

  const btn = e.target.closest("[button-wishlist]");
  if(!btn) return;

  const text = btn.getAttribute("data-tooltip");
  if(!text) return;

  const tooltip = document.createElement("div");
  tooltip.className = "global-tooltip";
  tooltip.innerText = text;

  document.body.appendChild(tooltip);

  const rect = btn.getBoundingClientRect();

  tooltip.style.top = rect.top - 35 + "px";  
  tooltip.style.left = rect.left + rect.width/2 + "px";

  setTimeout(()=>{
    tooltip.classList.add("show");
  },10);

  btn._tooltip = tooltip;

});

document.addEventListener("mouseout", function(e){

  const btn = e.target.closest("[button-wishlist]");
  if(!btn) return;

  if(btn._tooltip){
    btn._tooltip.remove();
    btn._tooltip = null;
  }

});

/******************* VARIATION TOOLTIP JS END *******************/ 